// import { CMAAuth } from 'root/services';
import { HPHttpClient } from './Client';

export const hpHttpClient = HPHttpClient({
  baseURL: process.env.BASE_URL_API,
  mockBaseURL: process.env.MOCK_BASE_URL_API,
  // authService: CMAAuth
});
